import React, { useEffect, useState } from "react";
import moment from "moment";

import { getDOY, _common } from "../common";
import { Functions } from "../Functions";
import { ServerInterface } from "../ServerInterface";
import DialogGast from "./DialogGast";
const common = _common;

export default function DialogBuchen(props: { date: Date; court: number; close: () => void; onReDraw: () => void }) {
  const { close, date, court, onReDraw } = props;

  const [publicBooking, setPublicBooking] = useState(true);
  const [partners, setPartners] = useState(new Array<string>());
  const [gastData, setGastData] = useState<any | undefined>();
  const [gastDialogOpen, setGastDialogOpen] = useState(false);
  const [numCourts, setNumCourts] = useState(1);
  const [numHours, setNumHours] = useState(1);
  const [text, setText] = useState("");

  const [spontan, setSpontan] = useState(false);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const inner = document.querySelector("#dialogBuchen");
    if (inner) {
      const f = Math.min(1, (window.innerWidth - 10) / inner.clientWidth);
      (inner as any).style.transform = `scale(${f})`;
      (inner as any).style.transformOrigin = "top";
    }
  });

  async function init() {
    try {
      const response = await fetch(`/booking/getpublicbooking?id=${common.userMemberId}`);
      const data = await response.text();
      // setPublicBooking(data == "public");

      /////////////////////////////////////////////

      setTimeout(function () {
        $("body").css("cursor", "default");
        $("#filerNames").focus();
      }, 100);

      updateAfterMemberClickedAndChecked("", partners);
    } catch (ex) {}
  }

  function filerNamesKeyup() {
    var filter = $("#filerNames")?.val();

    if (filter) {
      filter = `${filter}`.toUpperCase();

      if (filter == "@CHM") {
        window.location.href = "/?clubhausMode=true";
      }

      if (filter == "@ATM") {
        window.location.href = "/?anzeigeTafelMode=true";
      }

      var html = "";

      if (filter.length < 3) {
        html = "<li>Bitte gib mindestes 3 Buchstaben ein</li>";
      } else {
        for (var i in common.memberlist) {
          var member = common.memberlist[i];
          if (member.toUpperCase().indexOf(filter) >= 0 && !memberIsPartOfBooking(member)) {
            var ssMember = member.split(";");
            var oneMemberHtml = `<button class='memberButton' value='${member}'>${ssMember[1]}</button>`;
            html += oneMemberHtml;
          }
        }
      }

      $("#names").html(html);
      $(".hideDuringPartnerSelection").hide();
      $("info1").show();
    } else {
      $(".hideDuringPartnerSelection").show();
      $("info1").hide();
    }
  }

  //
  // prüfen ob member bereits in der buchung enthalten ist
  //
  function memberIsPartOfBooking(potentialPartner: string) {
    if (!common.clubhausMode) {
      if (potentialPartner.indexOf(common.userMemberId) >= 0) {
        // ich bin es selbst
        return true;
      }
    }

    for (var p in partners) {
      var partner = partners[p];
      if (partner == potentialPartner) {
        return true;
      }
    }

    return false;
  }

  function checkValidPartner(partner: string | undefined) {
    if (partner) {
      if (partner == "") {
        return false;
      }
    } else {
      return false;
    }

    if (common.clubhausMode) {
      //
      // im clubhausMode werden alle 2 / 4 Partner eingegeben
      //
      var id = parseInt(partner.split(";")[0]);
      if (id < 20) {
        // partner.superMember = true;
        return "@special@";
      }
    } else {
      for (var i in partners) {
        if (partner == partners[i]) {
          return false;
        }
      }
    }

    return true;
  }

  function createBookingInfo(xpartners: Array<string>): any {
    const d = new Date(date);

    const bookingInfo: any = {
      dateCreated: new Date(),
      court: court,
      numCourts: 1,
      date: d,

      // for backward compatibility
      dayIndex: getDOY(date),
      minutes: date.getMinutes(),
      hour: date.getHours(),
      ////////////////////////////////////////////////////////

      partners: [...xpartners],
      user: common.user,
      gastData: gastData,
      spontan: spontan,
    };

    const isSpezialBuchung = xpartners.length > 0 && parseInt(xpartners[0].split(";")[0]) <= common.maxSpecialIndex;
    if (isSpezialBuchung) {
      bookingInfo.numCourts = numCourts;
      bookingInfo.numHours = numHours;
      bookingInfo.text = text;
    }

    if (!common.clubhausMode && common.user) {
      bookingInfo.partners[bookingInfo.partners.length] = common.user.memberId + ";" + common.user.firstName + " " + common.user.lastName;
    }

    return bookingInfo;
  }

  async function onClickMemberButton(ev: any) {
    var partner = ev.target.attributes.value.value;

    var checkResult = checkValidPartner(partner);
    if (!checkResult) {
      return;
    }

    //
    // special id for training ....
    // Serienbuchung ermöglichen
    //
    var id = parseInt(partner.split(";")[0]);
    if (id <= 4) {
      $("#reservierenSerie").show();
    }

    const nextPartners = [...partners, partner];

    //
    // gesperrt etc doppelt eintragen
    // dadurch wird nachfolgender Code weniger verwirrt
    //
    const isSpezialBuchung = parseInt(partner.split(";")[0]) <= common.maxSpecialIndex;
    if (isSpezialBuchung) {
      nextPartners.push(partner);
    }

    const bookingInfo = createBookingInfo(nextPartners);

    var msg = await ServerInterface.checkBookingAllowed(bookingInfo);

    setSpontan(false);
    if (msg && msg == "@ok spontan") {
      setSpontan(true);
      msg = undefined;
    }

    if (msg && msg != "@special@") {
      common.myAlert(msg, "Reservierung nicht möglich");
    } else {
      if (!checkGastspieler(partner)) {
        setPartners(nextPartners);
      }
    }

    updateAfterMemberClickedAndChecked(msg, nextPartners);
  }

  function checkGastspieler(partner: string): boolean {
    try {
      var id = partner.split(";")[0];
      if (id == "9999") {
        var user = JSON.parse(common.getUserFromLocalStorage());

        ServerInterface.getIban(user.memberId).then((data: any | undefined) => {
          if (data) {
            const gastData = {
              iban: data.ibanF,
              bic: data.bic,
              bank: data.bank,
              name: "Gast",
              KontoInhaber: data.kontoInhaber,
              gastIstJugendlich: false,
            };
            setGastData(gastData);
            setGastDialogOpen(true);
          } else {
            common.myAlert("Es konnten keine Kontendaten für den Bankeinzug vom Server abgerufen werden", "Gastbuchung nicht möglich");
          }
        });

        return true;
      }
    } catch (ex) {}
    return false;
  }

  function updateAfterMemberClickedAndChecked(checkResult: string | undefined, partners: Array<any>) {
    var xHidePartnerSelection = false;
    var xShowReservieren = false;

    if (checkResult == "@special@") {
      xHidePartnerSelection = true;
      xShowReservieren = true;
    } else {
      if (common.clubhausMode) {
        //
        // im clubhausMode werden alle 2 / 4 Partner eingegeben
        //

        xHidePartnerSelection = partners.length == 4;
        xShowReservieren = partners.length == 2 || partners.length == 4;
      } else {
        xHidePartnerSelection = partners.length == 3;
        xShowReservieren = partners.length == 1 || partners.length == 3;
      }
    }

    if (xHidePartnerSelection) {
      $("#filterNames").hide();
      $(".partnerSelection").hide();
      $("#reservieren").focus();
    } else {
      $("#filterNames").show();
      $("#filerNames").val("");
      $("#names").html("");
      $("info1").hide();
      $(".hideDuringPartnerSelection").show();
      $("#filerNames").focus();
    }

    if (xShowReservieren) {
      $("#reservieren").attr("disabled", null);
    } else {
      $("#reservieren").attr("disabled", "disabled");
    }
  }

  function reservieren() {
    const bookingInfo = createBookingInfo(partners);

    Functions.book(bookingInfo).then(() => {
      close();
      onReDraw();
    });
  }

  function reservierenSerie() {
    const bookingInfo = createBookingInfo(partners);

    Functions.bookSerie(bookingInfo).then(() => {
      close();
      onReDraw();
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////

  async function makeBookingPrivate() {
    ServerInterface.makeBookingPublic(common.userMemberId, false);
    setPublicBooking(false);
  }

  async function makeBookingPublic() {
    ServerInterface.makeBookingPublic(common.userMemberId, true);
    setPublicBooking(true);
  }

  //////////////////////////////////////////////////////////////////////////////////////////////

  var isSpezialBuchung = false;
  if (partners.length > 0) {
    isSpezialBuchung = parseInt(partners[0].split(";")[0]) <= common.maxSpecialIndex;
  }

  return (
    <div
      id="dialogBuchen"
      style={{
        position: "relative",
        background: "white",
        width: "95%",
        maxWidth: "600px",
        minWidth: "400px",
        boxShadow: "var(--stdShadow)",
        borderRadius: "10px",
        overflow: "hidden",
      }}
    >
      {!gastDialogOpen && (
        <div className="modal-content">
          <div style={{ padding: "10px" }} className="modal-header">
            <h1 style={{ fontSize: "1em", fontWeight: "bold" }} className="modal-title">
              Reservierung vornehmen
            </h1>
          </div>

          <div style={{ paddingLeft: "10px", paddingTop: "10px", paddingRight: "10px", fontSize: "1em" }} className="modal-body">
            <div style={{ width: "100%", padding: 0 }} className="container">
              <table>
                <tbody>
                  <tr>
                    <td>Datum:</td>
                    <td>
                      &nbsp; &nbsp;
                      <b>
                        {date.toLocaleDateString(window.navigator.language, { weekday: "long" })} {date.toLocaleDateString()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td>Zeit:</td>
                    <td>
                      &nbsp; &nbsp;
                      <b>{date.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Platz:</td>
                    <td>
                      <b>
                        &nbsp; &nbsp;
                        {court}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>

              {spontan && <div>Dies ist eine Spontanbuchung</div>}

              <div style={{ marginTop: "1em" }} className="deinePartner">
                Dein(e) Partner(innen)
              </div>

              <div>
                <div className="partners">
                  {partners.map((partner) => (
                    <li key={partner.split(";")[0]}>{partner.split(";")[1]}</li>
                  ))}
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "row", marginTop: "10px", marginBottom: "10px" }}>
                <span>&#x1F50E;</span> <input id="filerNames" type="text" autoComplete="off" placeholder="Partner/in suchen" onKeyUp={filerNamesKeyup} />
              </div>

              <div className="partnerSelection">
                <div className="info1" style={{ display: "none" }}>
                  Tippe auf Deine/n Partner/in ...
                </div>
                <div id="selection1" style={{ maxHeight: "7em", overflow: "auto" }}>
                  <div onClick={onClickMemberButton} id="names" />
                </div>
              </div>

              {isSpezialBuchung && (
                <div>
                  <table>
                    <tbody>
                      <tr style={{ lineHeight: "50px" }}>
                        <td># Plätze:</td>
                        <td>
                          <div style={{ display: "flex", flexDirection: "row" }}>
                            <div style={{ paddingRight: "5px" }}>{numCourts}</div>
                            <input
                              type="range"
                              min="1"
                              max={7 - court + 1}
                              step="1"
                              defaultValue={numCourts}
                              onChange={(ev) => {
                                setNumCourts(parseInt(ev.target.value));
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td># Stunden:</td>
                        <td>
                          <div style={{ display: "flex", flexDirection: "row" }}>
                            <div style={{ paddingRight: "5px" }}>{numHours}</div>
                            <input
                              type="range"
                              min="1"
                              max={21 - date.getHours()}
                              step="1"
                              defaultValue={numHours}
                              onChange={(ev) => {
                                setNumHours(parseInt(ev.target.value));
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Text:</td>
                        <td>
                          <div style={{ marginTop: "20px", display: "flex", flexDirection: "row" }}>
                            <textarea
                              defaultValue={text}
                              onChange={(ev) => {
                                setText(ev.target.value);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "right",
                  marginTop: "1em",
                }}
              >
                {publicBooking && (
                  <div
                    id="makeBookingPrivate"
                    className="hideDuringPartnerSelection"
                    style={{
                      fontSize: "0.6em",
                      display: "flex",
                      flexDirection: "row",
                      width: "max-content",
                      alignItems: "end",
                    }}
                  >
                    <div style={{}}>Meine Buchungen werden öffentlich angezeigt.</div>

                    <div
                      style={{
                        paddingLeft: "10px",
                        fontSize: "1em",
                        color: "blue",
                        width: "max-content",
                      }}
                      onClick={() => makeBookingPrivate()}
                    >
                      Widerrufen...
                    </div>
                  </div>
                )}

                {!publicBooking && (
                  <div id="makeBookingPublic" className="hideDuringPartnerSelection" style={{ height: "3em" }}>
                    <button
                      type="button"
                      style={{
                        fontSize: "1em",
                        backgroundColor: "yellowgreen",
                        width: "max-content",
                      }}
                      className="btn"
                      onClick={() => makeBookingPublic()}
                    >
                      Meine Buchungen sind zur Zeit verdeckt
                      <br />
                      Andere Mitglieder sollen diese zuküftig sehen können
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div style={{ padding: "20px" }} className="modal-footer">
            <button type="button" data-dismiss="modal" style={{ backgroundColor: "indianred" }} className="btn" onClick={close}>
              Abbrechen
            </button>
            &nbsp; &nbsp;
            <button id="reservieren" type="button" onClick={reservieren} className="btn btn-primary">
              Reservieren
            </button>
            &nbsp; &nbsp;
            <button
              id="reservierenSerie"
              type="button"
              onClick={() => {
                reservierenSerie();
              }}
              style={{
                display: "none",
                backgroundColor: "yellowgreen",
              }}
              className="btn"
            >
              Serie Reservieren
            </button>
          </div>
        </div>
      )}

      {gastDialogOpen && (
        <DialogGast
          gastData={gastData}
          setGastData={(data) => {
            setGastDialogOpen(false);
            if (data) {
              setGastData(data);
              setPartners([...partners, "9999;Gast: " + data.name]);
            }
          }}
        />
      )}
    </div>
  );
}
